import { useState } from 'react';
import { Link } from 'react-router-dom';
import { api } from '@/lib/api';
import toast from 'react-hot-toast';
import { Mail, ChevronLeft, CheckCircle2 } from 'lucide-react';

const C = { or: '#B8960A', noir: '#1A1710', border: '#E8D8A8', orBg: '#FEF9EC' };

export default function ForgotPasswordPage() {
  const [email, setEmail] = useState('');
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post('/auth/forgot-password', { email });
      setSent(true);
    } catch {
      toast.error('Erreur lors de l\'envoi');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ minHeight: '100dvh', background: `linear-gradient(135deg, #F9F1E7 0%, #F2E4CC 100%)`, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 16 }}>
      <div style={{ background: '#fff', borderRadius: 20, boxShadow: '0 8px 40px rgba(26,23,16,0.12)', width: '100%', maxWidth: 420, padding: '40px 36px' }}>
        {/* Logo */}
        <div style={{ height: 48, backgroundImage: 'url(/logo_vaeg_assist.png)', backgroundSize: 'contain', backgroundPosition: 'center left', backgroundRepeat: 'no-repeat', marginBottom: 28 }} />

        {sent ? (
          <div style={{ textAlign: 'center', padding: '20px 0' }}>
            <div style={{ width: 56, height: 56, borderRadius: '50%', background: C.orBg, display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 16px' }}>
              <CheckCircle2 size={28} color={C.or} />
            </div>
            <h2 style={{ fontSize: 18, fontWeight: 700, color: C.noir, marginBottom: 8 }}>Email envoyé</h2>
            <p style={{ fontSize: 13, color: '#6b7280', lineHeight: 1.6, marginBottom: 24 }}>
              Si cet email est associé à un compte, vous recevrez un lien de réinitialisation dans les prochaines minutes.
            </p>
            <Link to="/login" style={{ fontSize: 13, color: C.or, fontWeight: 600, textDecoration: 'none', display: 'inline-flex', alignItems: 'center', gap: 6 }}>
              <ChevronLeft size={15} /> Retour à la connexion
            </Link>
          </div>
        ) : (
          <>
            <h1 style={{ fontSize: 20, fontWeight: 700, color: C.noir, marginBottom: 6 }}>Mot de passe oublié</h1>
            <p style={{ fontSize: 13, color: '#6b7280', marginBottom: 24, lineHeight: 1.6 }}>Saisissez votre email et nous vous enverrons un lien de réinitialisation.</p>

            <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
              <div>
                <label style={{ display: 'block', fontSize: 13, fontWeight: 600, color: '#374151', marginBottom: 6 }}>Adresse email</label>
                <div style={{ position: 'relative' }}>
                  <Mail size={15} style={{ position: 'absolute', left: 12, top: '50%', transform: 'translateY(-50%)', color: '#9ca3af' }} />
                  <input
                    type="email" value={email} onChange={e => setEmail(e.target.value)} required
                    placeholder="vous@entreprise.com"
                    style={{ width: '100%', paddingLeft: 36, paddingRight: 14, height: 42, border: `1px solid ${C.border}`, borderRadius: 9, fontSize: 13, outline: 'none', boxSizing: 'border-box', fontFamily: 'inherit' }}
                  />
                </div>
              </div>
              <button type="submit" disabled={loading} style={{ height: 42, background: C.or, color: '#fff', border: 'none', borderRadius: 9, fontSize: 14, fontWeight: 600, cursor: loading ? 'not-allowed' : 'pointer', opacity: loading ? 0.7 : 1 }}>
                {loading ? 'Envoi...' : 'Envoyer le lien'}
              </button>
            </form>

            <div style={{ textAlign: 'center', marginTop: 20 }}>
              <Link to="/login" style={{ fontSize: 13, color: '#6b7280', textDecoration: 'none', display: 'inline-flex', alignItems: 'center', gap: 4 }}>
                <ChevronLeft size={14} /> Retour à la connexion
              </Link>
            </div>
          </>
        )}
      </div>
    </div>
  );
}
